import { HealthDeclarationForm } from "@models/MLTC_R3/HealthDeclaration.model";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Step3State {
  healthDeclaration: HealthDeclarationForm | null;
  isCompleted: boolean;
  bmiCheckAttempt: number;
}

const initialState: Step3State = {
  healthDeclaration: null,
  isCompleted: false,
  bmiCheckAttempt: 0,
};

const step3Slice = createSlice({
  name: 'MLTC-R3-Step3',
  initialState,
  reducers: {
    updateHealthDeclaration: (state,action: PayloadAction<HealthDeclarationForm| null>) => {
      state.healthDeclaration = action.payload;
    },
    updateStepCompleted: (state,action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateBmiCheckAttempt: (state) => {
      state.bmiCheckAttempt += 1;
    }
  }
})

export const { updateHealthDeclaration,updateStepCompleted, updateBmiCheckAttempt } = step3Slice.actions;

export default step3Slice.reducer;